module.exports = __webpack_public_path__ + "img/test03-6.676cc8f4.jpg";